{
	"name": "old_wood",
	"roles": {
		"none": [0, 0, 0, 0],
		"outline": [26, 16, 10, 255],
		"white": [255, 255, 255, 255],
		"casing": [122, 79, 44, 255],
		"casing_lit": [156, 106, 62, 255],
		"casing_shadow": [86, 54, 30, 255],
		"casing_darkest": [52, 32, 18, 255],
		"rim": [140, 94, 54, 255],
		"rivet": [176, 126, 78, 255],
		"recess": [70, 44, 24, 255],
		"trim": [54, 50, 48, 255],
		"trim_lit": [96, 92, 88, 255],
		"trim_dark": [30, 28, 26, 255],
		"brass": [176, 138, 58, 255],
		"brass_lit": [214, 180, 96, 255],
		"hazard": [176, 138, 58, 255],
		"good": [120, 148, 78, 255],
		"good_dark": [78, 98, 52, 255],
		"warn": [198, 150, 60, 255],
		"bad": [154, 62, 44, 255],
		"grain": [104, 66, 36, 255],
		"grain_lit": [140, 96, 56, 255],
		"glass": [180, 200, 190, 70]
	},
	"ramps": {
		"fill": ["casing_shadow", "casing", "casing_lit"],
		"charge": ["bad", "warn", "good"]
	}
}
